import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Anchor, Phone, MapPin, Facebook, Instagram } from "lucide-react";
import { api, fileUrl } from "@/lib/api";

export function Footer() {
  const [settings, setSettings] = useState({});
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    api.get("/location-pages").then((r) => setLocations(r.data || [])).catch(() => {});
  }, []);
  const phone = settings.phone || "423-878-3520";
  const social = settings.social || {};
  const hours = settings.hours || [];
  const heading = "text-mtm-purple-deep font-heading font-bold text-sm uppercase tracking-wider mb-4";
  const link = "text-slate-600 hover:text-mtm-purple transition-colors";

  return (
    <footer className="bg-white border-t-4 border-mtm-purple" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 pt-14 pb-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <Link to="/" className="inline-flex items-center mb-5">
            {settings.logo_path ? (
              <img src={fileUrl(settings.logo_path, 480)} alt="MTM Marine Sales & Service" className="w-52 h-auto object-contain block" />
            ) : (
              <span className="flex items-center gap-2.5">
                <span className="h-11 w-11 rounded-lg bg-gradient-to-br from-mtm-purple-deep to-mtm-violet flex items-center justify-center text-white"><Anchor size={24} /></span>
                <span className="font-heading font-extrabold text-xl text-mtm-purple-deep">MTM Marine</span>
              </span>
            )}
          </Link>
          <p className="text-sm text-slate-500 max-w-sm mb-5">{settings.footer_tagline || "Your local Falcon Boats and Armada Pontoons dealer in Bristol, TN."}</p>
          <div className="space-y-2.5 text-sm text-slate-700">
            <p className="flex items-start gap-2"><MapPin size={17} className="text-mtm-teal mt-0.5 shrink-0" /> <span>{settings.address_line || "3525 US-421 Scenic"}, {settings.city_state_zip || "Bristol, TN 37620"}</span></p>
            <a href={`tel:${phone.replace(/[^0-9]/g, "")}`} className="flex items-center gap-2 hover:text-mtm-purple"><Phone size={17} className="text-mtm-teal shrink-0" /> {phone}</a>
          </div>
          <div className="flex gap-3 mt-5">
            {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-9 w-9 rounded-full bg-mtm-purple/10 text-mtm-purple hover:bg-mtm-purple hover:text-white flex items-center justify-center transition-colors"><Facebook size={16} /></a>}
            {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-9 w-9 rounded-full bg-mtm-purple/10 text-mtm-purple hover:bg-mtm-purple hover:text-white flex items-center justify-center transition-colors"><Instagram size={16} /></a>}
          </div>
        </div>

        <div>
          <h4 className={heading}>Inventory</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/inventory?condition=new" className={link}>New Inventory</Link></li>
            <li><Link to="/inventory?condition=used" className={link}>Used Inventory</Link></li>
            <li><Link to="/inventory" className={link}>All Boats</Link></li>
            <li><Link to="/brands/falcon" className={link}>Falcon Boats</Link></li>
            <li><Link to="/brands/armada" className={link}>Armada Pontoons</Link></li>
          </ul>
        </div>

        <div>
          <h4 className={heading}>Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/service" className={link}>Marine Service</Link></li>
            <li><Link to="/financing" className={link}>Financing</Link></li>
            <li><Link to="/about" className={link}>About MTM</Link></li>
            <li><Link to="/contact" className={link}>Contact</Link></li>
            <li><Link to="/admin/login" className="text-slate-400 hover:text-mtm-purple">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className={heading}>Areas Served</h4>
          <ul className="space-y-2.5 text-sm">
            {locations.map((l) => (
              <li key={l.slug}><Link to={`/locations/${l.slug}`} className={link}>{l.city}</Link></li>
            ))}
          </ul>
          <h4 className={`${heading} mt-6 mb-3`}>Hours</h4>
          <ul className="space-y-1 text-xs text-slate-500">
            {hours.map((h, i) => (<li key={i}>{h.day}: {h.value}</li>))}
          </ul>
        </div>
      </div>

      <div className="bg-mtm-purple-deep text-purple-100/80">
        <div className="max-w-7xl mx-auto px-4 py-4 text-xs flex flex-col sm:flex-row justify-between gap-2">
          <p>© {new Date().getFullYear()} MTM Marine Sales & Service. All rights reserved.</p>
          <p>Bristol, Tennessee. Falcon Boats and Armada Pontoons Dealer.</p>
        </div>
      </div>
    </footer>
  );
}
